module.exports = __webpack_public_path__ + "img/cerrar-sesion.a5ba1787.svg";